<template>
  <el-dialog
    title="选择抢购"
    width="520px"
    :visible.sync="dialogFlashSale.isShow"
    append-to-body
    @open='open'
  >
    <el-form :inline="true" @submit.native.prevent>      
      <el-form-item >
        <el-input  placeholder="抢购名称" size="medium" @keyup.enter.native="Search" v-model="name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" v-on:click="Search" >查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" style="width: 100%">
      <el-table-column  prop="Title" :show-overflow-tooltip="true" label="名称"> </el-table-column>
      <el-table-column  prop="Price" label="价格"> </el-table-column>
      <el-table-column  prop="Count" label="次数"> </el-table-column>
      <el-table-column  fixed="right" width="70px" label="操作" >
        <template slot-scope="scope">
          <el-button @click.native.prevent="Select(scope.row)" type="text" size="small">
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :total="totalCount">
    </el-pagination>
  </el-dialog>
</template>
<script  type='text/ecmascript-6'>
   import { Loading } from 'element-ui';
   export default {
    props:{
      dialogFlashSale:{        
      }
    },
    data(){
      return {
        name:'',
        pageIndex:1,
        pagesize:5,
        totalCount:0,
        sort:' id desc',
        rows:[],
        loading:false
      }
    },
    mounted(){
      
    },
    methods:{
      open:function(){
        this.GetData()
      },
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/FlashSale/Index',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.rows = resp.data.flashSales
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleCurrentChange(val) {
        this.pageIndex = val 
        this.GetData()
      },
      Select(row){ 
        this.$emit('UpdateFlashSale',row.Id,row.Title)
        this.dialogFlashSale.isShow = false
      }

    }
   }
</script>
